import * as React from 'react';
import autobind from 'autobind-decorator';
import VideoContent from './VideoContent';
import VideoTOC from './VideoTOC';
import VideoSlide from './VideoSlide';
import Video from './Video';
import VideoVote from './VideoVote';
import { Container, Row, Col, Accordion, Card, Button, Jumbotron } from 'react-bootstrap';


// utils
import postData from 'Utils/PostData';
import patchData from 'Utils/PatchData';
import deleteData from 'Utils/DeleteData';

import '../Assets/video.sass'
import MarkerForm from './MarkerForm';
import SectionMarker from './SectionMarker';
import QuizMarker from './QuizMarker';

export interface IConceptVideoBoxProps {
    data: any;
    concept: any;
    refresh: any;
}

export interface IConceptVideoBoxState {
    title: string;
    content: Object;
    currentMarker: number;
    markers: Array<any> | undefined;
    startTime: number;
    videoLength: number;
    showMarkerForm: boolean;
    showMarkerEdit: boolean;
    markerArea: any;
}

export default class ConceptVideoBox extends React.Component<IConceptVideoBoxProps, IConceptVideoBoxState> {

    private videoRef: React.RefObject<any>;

    constructor(props: IConceptVideoBoxProps) {
        super(props);

        const data = this.props.data;
        let cur_marker = 0;
        if (data.content.markers.length == 0) {
            cur_marker = -1;
        }

        this.videoRef = React.createRef();
        this.state = {
            title: data.content.title,
            content: data.content.content,
            currentMarker: cur_marker,
            markers: data.content.markers,
            startTime: 0,
            videoLength: data.content.duration,
            markerArea: null,
            showMarkerEdit: false,
            showMarkerForm: false
        };
    }

    @autobind
    public updateDesc(newTitle, newContent) {
        this.setState({
            title: newTitle,
            content: newContent
        })
        // this.props.refresh();
    }


    @autobind
    public changeCurrent(index) {
        let start_time = this.state.markers[index]['time'];
        console.log('changeCurrent=>', index, start_time);
        this.setState({
            currentMarker: index,
            startTime: start_time,
        });
        this.showMarkerEdit();
    }

    @autobind
    setMarkerArea(index) {

    }

    @autobind
    public updateSeek(time) {
        this.setState({
            startTime: time
        })
    }

    @autobind
    showMarkerForm(flag = true) {
        if (flag) {
            this.setState({
                showMarkerEdit: false,
                showMarkerForm: true
            })
            // pause the video using ref
            this.videoRef.current.customPause();
        }
        else {
            this.setState({
                showMarkerEdit: false,
                showMarkerForm: false
            })
            // play the video using ref
            this.videoRef.current.customPlay();
        }
    }

    @autobind
    showMarkerEdit(flag = true) {
        if (flag) {
            this.setState({
                showMarkerEdit: true,
                showMarkerForm: false
            })
            // pause the video using ref
            this.videoRef.current.customPause();
        }
        else {
            this.setState({
                showMarkerEdit: false,
                showMarkerForm: false
            })
            // play the video using ref
            this.videoRef.current.customPlay();
        }
    }

    @autobind
    saveMarker(title: string, type: string) {
        // get current time of video from ref
        const ctime = this.videoRef.current.getCurrentTime();

        if (type === 'S') {
            // save section marker
            const payload = {
                title,
                type,
                video: this.props.data.content.id,
                time: ctime
            }
            const url = `/video/api/marker/?format=json`;
            postData(url, payload)
                .then(res => {
                    console.log(res);
                    const len = this.state.markers.length;
                    this.setState({
                        markers: res['markers']
                    }, () => { this.changeCurrent(len) });
                    // this.props.refresh();
                })
                .catch(err => console.log(err));
        }
        else {

        }
    }

    public render() {

        const data = this.props.data;
        return (

            <Row style={{ overflow: 'auto' }}>
                <Col md={{ span: 4 }}>
                    <Accordion defaultActiveKey="0">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey="0">
                                Description
                                 </Accordion.Toggle>

                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <VideoContent content={this.state.content} videoId={data.content.id}
                                        title={this.state.title} saveCallback={this.updateDesc}
                                        is_editable={data.content.is_editable} />
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>

                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey="1">
                                Table Of Content
                                 </Accordion.Toggle>

                            <Accordion.Collapse eventKey="1">
                                <Card.Body>
                                    <VideoTOC
                                        markers={this.state.markers}
                                        clickCallback={this.changeCurrent}
                                    />
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>

                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey="2">
                                Slides
                                 </Accordion.Toggle>

                            <Accordion.Collapse eventKey="2">
                                <Card.Body>
                                    <VideoSlide id={data.content.id} other_file={data.content.other_file} />
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </Col>

                <Col md={{ span: 8 }}>
                    <div className="video-panel">
                        <Row>
                            <Col className="video-panel-heading" md-span={12}>
                                <h4>{this.state.title}</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col md-span={12}>
                                <Video
                                    ref={this.videoRef}
                                    videoFile={data.content.video_file}
                                    videoStartTime={this.state.startTime}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md-span={12}>
                                <VideoVote upvotes={data.content.upvotes} downvotes={data.content.downvotes}
                                    addMarker={this.showMarkerForm} updateSeek={this.updateSeek} />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col md-span={12}>
                                {
                                    this.state.showMarkerForm ?
                                        <MarkerForm
                                            saveCallback={this.saveMarker}
                                            cancelCallback={() => this.showMarkerForm(false)}
                                        />
                                        :
                                        (
                                            this.state.showMarkerEdit ?
                                                (
                                                    this.state.markers[this.state.currentMarker].type === 'Q' ?
                                                        <QuizMarker
                                                            marker={this.state.markers[this.state.currentMarker]}
                                                            cancelCallback={() => this.showMarkerEdit(false)}
                                                        />
                                                        :
                                                        <SectionMarker
                                                            marker={this.state.markers[this.state.currentMarker]}
                                                            cancelCallback={() => this.showMarkerEdit(false)}
                                                        />
                                                )
                                                :
                                                null
                                        )
                                }
                            </Col>
                        </Row>
                    </div>
                </Col>

            </Row>

        )
    }
}
